import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 122 45'
    {...props}
  >
    <path
      fill='#EA4335'
      d='M52.716 23.471c0 5.324-4.165 9.246-9.275 9.246s-9.275-3.922-9.275-9.246c0-5.36 4.164-9.245 9.275-9.245 5.11 0 9.275 3.885 9.275 9.245m-4.06 0c0-3.326-2.414-5.602-5.215-5.602-2.802 0-5.215 2.276-5.215 5.602 0 3.294 2.413 5.603 5.215 5.603s5.215-2.314 5.215-5.603'
    />
    <path
      fill='#FBBC05'
      d='M72.725 23.471c0 5.324-4.164 9.246-9.275 9.246-5.11 0-9.275-3.922-9.275-9.246 0-5.356 4.164-9.245 9.275-9.245 5.11 0 9.275 3.885 9.275 9.245m-4.06 0c0-3.326-2.414-5.602-5.215-5.602s-5.215 2.276-5.215 5.602c0 3.294 2.414 5.603 5.215 5.603s5.215-2.314 5.215-5.603'
    />
    <path
      fill='#4285F4'
      d='M91.9 14.784v16.6C91.9 38.21 87.875 41 83.114 41c-4.48 0-7.178-2.997-8.195-5.448l3.535-1.472c.63 1.505 2.172 3.281 4.656 3.281 3.047 0 4.936-1.88 4.936-5.42v-1.329h-.142c-.909 1.122-2.66 2.101-4.869 2.101-4.623 0-8.858-4.027-8.858-9.208 0-5.22 4.235-9.28 8.858-9.28 2.205 0 3.956.98 4.869 2.068h.142v-1.505H91.9zm-3.568 8.72c0-3.255-2.171-5.635-4.935-5.635-2.802 0-5.148 2.38-5.148 5.636 0 3.222 2.347 5.569 5.148 5.569 2.763 0 4.935-2.347 4.935-5.57'
    />
    <path fill='#34A853' d='M98.257 5.055V32.15h-3.96V5.055z' />
    <path
      fill='#EA4335'
      d='m113.69 26.515 3.151 2.1c-1.017 1.506-3.468 4.098-7.703 4.098-5.253 0-9.175-4.06-9.175-9.245 0-5.499 3.956-9.246 8.72-9.246 4.798 0 7.145 3.818 7.912 5.882l.421 1.05-12.36 5.119c.947 1.855 2.418 2.801 4.482 2.801 2.067 0 3.501-1.017 4.552-2.56m-9.701-3.327 8.262-3.43c-.454-1.155-1.821-1.96-3.43-1.96-2.064 0-4.936 1.822-4.832 5.39'
    />
    <path
      fill='#4285F4'
      d='M19.176 21.066v-3.923h13.218c.13.684.196 1.493.196 2.368 0 2.943-.805 6.582-3.397 9.175-2.522 2.626-5.745 4.027-10.013 4.027-7.912 0-14.565-6.445-14.565-14.356C4.615 10.445 11.268 4 19.18 4c4.377 0 7.495 1.717 9.838 3.956l-2.768 2.768c-1.68-1.576-3.956-2.801-7.074-2.801-5.778 0-10.297 4.656-10.297 10.434S13.4 28.79 19.176 28.79c3.747 0 5.882-1.505 7.249-2.872 1.109-1.109 1.838-2.693 2.126-4.856z'
    />
  </svg>
);
export default SvgLogoGoogle;
